import debug from 'debug';
import Settings from '../data/settings';

const log = debug('SearchBox:Events:Awesomplete');

class Awesomplete {
	constructor(element) {
		this.element = element;

		this.eventListeners();
	}

	eventListeners() {
		this.element.addEventListener('awesomplete-select', event => {
			// Change page to the selected url
			window.location.href = event.text.value.url;
			
		}, false);

		this.element.addEventListener('awesomplete-selectcomplete', event => {
			// the selected value is set in the input, but since we have an object as the value
			// we force the label instead, to prevent the user from seeing [object OBJECT] in the search field
			this.element.value = event.text.label;
		}, false);

		this.element.addEventListener('awesomplete-highlight', () => {
			// Whenever the user highlights an item indicate that we have something highlighted
			Settings.isHighlighted = true;
		});

		this.element.addEventListener('awesomplete-close', (event) => {
			// The event is fired whenever the awesomplete closes, also if the user press enter
			// We only want to remove info about the highlighted if the user closes the input, not
			// if they select with enter.
			if (event.reason !== 'select') {
				Settings.isHighlighted = false;
			}
			
		});
	}
}

export default Awesomplete;
